export default __webpack_public_path__ + "static/media/profile_male.933552d1.png";